import { Checkbox } from '@/base_components/ui/checkbox'
import { TimeOfDay } from 'constants/common'
import styles from './index.module.scss'

type TimeOfDayCheckboxProps = {
  filters: ProviderFilter[]
  timeOfDay: TimeOfDay[]
  setTimeOfDay: (timeOfDay: TimeOfDay[]) => void
}

const TimeOfDayCheckbox = ({
  filters,
  timeOfDay,
  setTimeOfDay,
}: TimeOfDayCheckboxProps): JSX.Element => {
  return (
    <div className={styles.timeOfDayFilter}>
      <p className="~font-gibson ~text-medium-grey ~text-xl ~mb-4 ~mx-2.5">
        What time of day do you prefer?
      </p>
      <div className="~flex ~flex-col sm:~flex-row ~flex-wrap ~mx-2.5">
        {filters.map(({ id, value, description }) => (
          <div key={id} className="~w-full sm:~w-1/2 ~flex ~items-center ~mb-4">
            <Checkbox
              checked={timeOfDay.includes(id as TimeOfDay)}
              onCheckedChange={(checked) =>
                setTimeOfDay(
                  checked
                    ? ([...timeOfDay, id] as TimeOfDay[])
                    : timeOfDay.filter((v) => v !== id)
                )
              }
              className="~w-5 ~h-5 ~border-medium-grey data-[state=checked]:~bg-grass data-[state=checked]:~text-white data-[state=checked]:~border-white"
            />{' '}
            <span className="~font-medium ~text-base ~ml-2">{value}</span>{' '}
            <span className="~text-medium-grey ~text-base ~ml-1">
              {description}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TimeOfDayCheckbox
